import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--content"
export default class extends Controller {
  static targets = [
    "form",
    "content",
    "showFormButton"
  ]

  static values = {
    show: String
  }

  connect() {
    this.elFormTarget = document.querySelector("[data-admins--content-target='form']")
    this.elContentTarget = document.querySelector("[data-admins--content-target='content']")

    if (this.showValue === "form") {
      this.elFormTarget.classList.remove("hidden")
      this.elContentTarget.classList.add("hidden")
    }

    if (this.showValue === "content") {
      this.elContentTarget.classList.remove("hidden")
      this.elFormTarget.classList.add("hidden")
    }
  }

  showForm() {
    this.formTarget.classList.remove("hidden")
    this.contentTarget.classList.add("hidden")

    this.showFormButtonTarget.classList.add("hidden")
  }

  showContent() {
    this.formTarget.classList.add("hidden")
    this.contentTarget.classList.remove("hidden")

    this.showFormButtonTarget.classList.remove("hidden")
  }
}
